// components/GlobalAlert.js
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hideAlert } from '../../store/reducers/alertReducer';
import '../Alert/GlobalAlert.css';

const GlobalAlert = () => {
  const dispatch = useDispatch();
  const { type, message, visible } = useSelector(state => state.alertList);

  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        dispatch(hideAlert());
      }, 5000); // Auto-hide after 3 seconds
      return () => clearTimeout(timer);
    }
  }, [visible, dispatch]);

  console.log("alertType",type);

  if (!visible) return null;

  return (
    <div className={`alert-box ${type}`}>
      {message}
    </div>
  );
};

export default GlobalAlert;
